/**
 * Client-side file download from text content (CSV exports). The server sends
 * the document text (already BOM-prefixed); we wrap it in a Blob so the
 * browser saves it under the server-suggested filename. The object URL is
 * revoked after the click so nothing lingers.
 */
export function downloadTextFile(
  filename: string,
  text: string,
  mimeType = 'text/csv;charset=utf-8',
): void {
  const blob = new Blob([text], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
